import React from 'react'
import { ControlLabel } from '../label/Label'
import PasswordComp from '../password/PasswordComp'
import './labeledInput.scss'

const LabeledPassword = ({
  classNameBox,
  idLabel,
  required,
  name,
  value,
  onChange,
  ...propsPassword
}) => {
  return (
    <div className={`flex-container ${classNameBox}`}>
      <ControlLabel id={idLabel} required={required} />
      <div className="control-input">
        <PasswordComp
          name={name}
          value={value}
          onChange={onChange}
          {...propsPassword}
        />
      </div>
    </div>
  )
}

export default LabeledPassword
